// extracted by mini-css-extract-plugin
export var annoucement = "Annoucement-module--annoucement--f8343";
export var boldText = "Annoucement-module--boldText--e9c8a";
export var btn = "Annoucement-module--btn--f48c4";
export var btnText = "Annoucement-module--btnText--cbe14";
export var left = "Annoucement-module--left--a26b0";
export var msg = "Annoucement-module--msg--3b25a";
export var right = "Annoucement-module--right--cbb1c";